import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import Toolmenu from 'core/components/toolmenu/toolmenu';
import mdEntityService from 'core/metamodel/mdEntityService';
import mdConfigService from "core/metamodel/mdConfigService";
import {formatId, parseId} from "core/common/utils/utils";
import {FormProps, IDomainObject, lovLabel, lovValue, preSave} from "core/form/formUtils";
import {ErrorComp} from "core/components/errorComp/errorComp"
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import FieldDefaultList from "core/metamodel/component/fieldDefaultList";
import {MODULE, PageProps, PERMISSION} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {ZzFlatButton} from "core/components/buttons/buttons";
import uiService from "core/common/service/uiService";
import {action} from "mobx";
import FieldValidationList from "core/metamodel/component/fieldValidationList";
import {DynamicFieldConfig, MdFieldDto} from "core/metamodel/metaDomain";
import LocalizeFields from "core/components/localization/localizeFields";
import MdField, {FIELDTYPE} from "core/metamodel/mdField";
import {createForm} from "core/form/createForm";
import {BlockComp} from "core/components/blockComp/blockComp";
import {Validate} from "core/form/validate";
import {MdCheckbox, MdTextField} from "core/components/fields/fields";
import {PrimaryKeyString} from "core/form/rules";
import StyledSelect from "core/components/fields/styledSelect";
import gridService from "core/grid/gridService";
import {GridComposite, MovingBlocks} from "core/grid/gridUtils";
import Grid from "core/grid/domain/grid";
import GridComp, {GridCompositeComp} from "core/grid/component/gridComp";
import {getSelectTenant, getSelectTenantGroup, setSelectTenant, setSelectTenantGroup} from "core/tenant/tenantSelectionSupport";
import {PRICECOMPLEVEL, PriceComponent} from "product/productDomain";
import {ValidationMessage} from "core/common/domain/commonDomain";

const tenantGridLocation = 'tenantList';
const tenantGroupListLocation = 'tenantGroupList';
const tenantGridComposite = 'tenantGridComposite';

@observer
export default class EntityFieldDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'Field';
  static icon = 'book';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("EntityFieldDetail#fetchData(%O)", routerParams.id);
    const [entityName, fieldName] = parseId(routerParams.id);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['DynamicFieldConfig', 'FieldDefaultTable', 'FieldValidationTable'], [entityName, 'MdField']);
    let gridPromise = gridService.fetchGrids(tenantGridLocation, tenantGroupListLocation);

    let fieldDtoPromise: Promise<MdFieldDto>;

    if (fieldName === 'new') {
      fieldDtoPromise = Promise.resolve(new MdFieldDto({
        entityName: entityName,
        fieldType: FIELDTYPE.DYNAMIC,
        dynamicFieldConfig: {
          entityName: entityName,
          active: true,
          $new: true
        },
        $new: true,
        active: true
      }));
    } else {
      fieldDtoPromise = mdConfigService.readFieldDto(routerParams.id);
    }



    return Promise.all([fieldDtoPromise, metadataPromise, gridPromise])
      .then(([mdFieldDto, entityMap, gridLocationMap]) => {

        mdFieldDto.$movingBlocks = new MovingBlocks(tenantGridComposite, false, null,
          new GridComposite(tenantGridComposite, 'Tenant selection', new Grid(gridLocationMap.get(tenantGridLocation)), new Grid(gridLocationMap.get(tenantGroupListLocation))),
        );

        mdConfigService.fieldObject = mdFieldDto.initAfterRead(routerParams.id === 'new');
        console.log("fieldObject = %o", mdConfigService.fieldObject);
      });
  }


  /**
   * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    if(this.idChanged(prevProps.params.id, this.props.params.id)) {
      mdConfigService.fieldObject.$movingBlocks.searchExposedGrids(mdConfigService.fieldObject);
    }
  }

  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    mdConfigService.fieldObject.$movingBlocks.searchExposedGrids(mdConfigService.fieldObject);
  }

  componentWillUnmount() {
    mdConfigService.fieldObject = null;
  }


  findRootObject() {
    return mdConfigService.fieldObject;
  }


  customValidate = (fieldObject: MdFieldDto) => {
    let errors: ValidationMessage[] = [];

    if (fieldObject.$new) {
      let entity = mdEntityService.getEntity(fieldObject.entityName);
      if (entity.getField(fieldObject.dynamicFieldConfig.fieldName)) {
        errors.push({message: "Field " + fieldObject.dynamicFieldConfig.fieldName + " already exists on the entity"});
      }
    }
    return errors;
  };

  @action onSave = (evt) => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();
    let fieldObject = mdConfigService.fieldObject;

    if (!preSave(fieldObject, this.customValidate)) {
      return;
    }

    mdConfigService.saveFieldDto(fieldObject)
      .then(action("fieldDtoSave-action", (foJson: IDomainObject) => {
        let wasNew = fieldObject.cleanAfterSave(foJson);
        if (wasNew) {
          this.context.router.replaceWith('entityFieldDetail', {id:  fieldObject.getId()});
        }
        uiService.hideToolbarActionFlag();
      }), error => {
        fieldObject.$errors = error.getMessages();
      });
  };


  onBack = (evt) => {
    this.context.router.transitionTo('entityDetail', {id: mdConfigService.fieldObject.entityName});
  };

  render() {
    let {query} = this.props;
    let dynFieldConfigEntity = mdEntityService.getEntity("DynamicFieldConfig");

    let movingBlocks = mdConfigService.fieldObject.$movingBlocks;

    return (
      <main className="main-content" style={{display: 'flex', flexDirection: 'column'}}>
        {this._createToolMenu(query.gridLocation)}
        <ErrorComp messages={mdConfigService.fieldObject.$errors}/>
        <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>

        {
          mdConfigService.fieldObject.fieldType === FIELDTYPE.DYNAMIC && (
            <div>
              <DynamicFieldConfigForm dataObject={mdConfigService.fieldObject.dynamicFieldConfig} entities={mdEntityService.entityMap}
                                      rootObject={mdConfigService.fieldObject} entity={dynFieldConfigEntity}/>

              <GridCompositeComp grid={movingBlocks.getBlock(tenantGridComposite) as GridComposite} uiLocation={movingBlocks.getUiLocation(tenantGridComposite)} >
                <div className="col-xs-12 col-sm-6" style={{padding: 10}}>
                  <h4>Select Tenants</h4>
                  <GridComp grid={(movingBlocks.getBlock(tenantGridComposite) as GridComposite).groupMembers[0]} multiSelect={false} hideToolbar={true} gridClassName="detail-grid"
                            uiLocation={movingBlocks.getUiLocation(tenantGridComposite)} functionMap={{getSelectTenant: getSelectTenant.bind(this, mdConfigService.fieldObject.dynamicFieldConfig), setSelectTenant: setSelectTenant.bind(this, mdConfigService.fieldObject.dynamicFieldConfig)}}
                            entities={mdEntityService.entityMap} />
                </div>
                <div className="col-xs-12 col-sm-6" style={{padding: 10}}>
                  <h4>or select Tenant Groups</h4>
                  <GridComp grid={(movingBlocks.getBlock(tenantGridComposite) as GridComposite).groupMembers[1]} multiSelect={false} hideToolbar={true} gridClassName="detail-grid"
                            uiLocation={movingBlocks.getUiLocation(tenantGridComposite)} functionMap={{getSelectTenantGroup: getSelectTenantGroup.bind(this, mdConfigService.fieldObject.dynamicFieldConfig), setSelectTenantGroup: setSelectTenantGroup.bind(this, mdConfigService.fieldObject.dynamicFieldConfig)}}
                            entities={mdEntityService.entityMap} />
                </div>
              </GridCompositeComp>
            </div>
          )
        }

        {
          mdConfigService.fieldObject.fieldType !== FIELDTYPE.DYNAMIC && (
            <h1>{ mdConfigService.fieldObject.entityName } / { mdConfigService.fieldObject.fieldName }</h1>
          )
        }




        <form style={{marginTop: 10}}>
          <div className="row">

            <div className="col-xs-12 col-sm-6 block-comp-right-border">
              <LocalizeFields fields={mdConfigService.fieldObject.locales.entries().map(([fieldName, locArray]) => ({fieldName, locArray}))}/>
            </div>


            <div className="col-xs-12 col-sm-6">
              <FieldDefaultList fieldObject={mdConfigService.fieldObject} rootObject={mdConfigService.fieldObject}
                                entities={mdEntityService.entityMap}
                                entity={mdEntityService.getEntity('FieldDefaultTable')}/>
              <FieldValidationList fieldObject={mdConfigService.fieldObject} rootObject={mdConfigService.fieldObject}
                                   entities={mdEntityService.entityMap}
                                   entity={mdEntityService.getEntity('FieldValidationTable')}/>
            </div>
          </div>
        </form>


      </main>
    );


  }


  _createToolMenu(gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={false}>
        <ZzFlatButton onClick={this.onSave} label="Save Field" permission={PERMISSION.Update}/>
      </Toolmenu>
    );
  }
}







@createForm({
  formName: 'DynamicFieldConfigForm',
  fields: [{
    name: 'fieldName',
    validators: ['IsRequired']
  }, {
    name: 'dataType',
    validators: ['IsRequired'],
  }, {
    name: 'defaultLabel',
    validators: ['IsRequired']
  }, {
    name: "active"
  }]
}, () => <noscript/> )
@observer
class DynamicFieldConfigForm extends React.Component<FormProps<DynamicFieldConfig, MdFieldDto>, undefined> {

  render() {
  let {dataObject, rootObject, entity, entities, form, formName} = this.props;
    let fields = form.fields;
    let {
      fieldName, dataType, defaultLabel, active
    } = dataObject.getFormFields(formName);

    return (
      <form style={{marginTop: 10}}>
        <BlockComp>

          <div className="row">
            <div className="fx col-xs-6 col-sm-4">
              <MdTextField {...fieldName.props} disabled={!dataObject.$new} />
              <Validate field={fieldName} value={fieldName.props.value}>
                <PrimaryKeyString/>
              </Validate>
            </div>

            <div className="fx col-xs-6 col-sm-2">
              <StyledSelect  {...dataType.props} clearable={false} disabled={!dataObject.$new}/>
              <Validate field={dataType} value={dataType.props.value} />
            </div>

            <div className="fx col-xs-10 col-sm-5">
              <MdTextField {...defaultLabel.props} />
              <Validate field={defaultLabel} value={defaultLabel.props.value}/>
            </div>

            <div className="fx col-xs-2 col-sm-1">
              <MdCheckbox {...active.props} />
            </div>

          </div>
        </BlockComp>
      </form>

    )
  }

}





// WEBPACK FOOTER //
// ./src/core/metamodel/entityFieldDetail.tsx